import { Button, CircularProgress, Icon, IconButton, Typography } from '@material-ui/core';
import InsertDriveFileOutlinedIcon from '@material-ui/icons/InsertDriveFileOutlined';
import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import Label from 'src/components/Label';
import { s3 } from 'src/services/awsS3';
import {
  addFile,
  allClear,
  appendCurrentList,
  clearUploaded,
  onClear,
  updateCurrentList,
  updateFile,
  UpdateFileCancelAction,
  UpdateFileInqueueAction,
  updateFileToDb,
  updateFileUploadedToDb,
  updateFileUploadedToS3,
} from 'src/store/actions/fileExplorer.action';
import { bytesToSize, getEnvVars } from 'src/utils';
import { v4 as uuidv4 } from 'uuid';
import {
  ButtonHeader,
  fileExplorerStyles,
  UploadBar,
  UploadBarFull,
  UploadBarTop,
  UploadFileView,
  UploadList,
  UploadRow,
  UploadRowAction,
} from './fileExplorerStyles';

const ChatBar = props => {
  const classes = fileExplorerStyles();
  const dispatch = useDispatch();
  const [chatBarFullMode, setChatBarFullMode] = useState(false);
  const [uploadObjects, setUploadObjects] = useState([]);
  const { currentState, updateFile, isSignedin } = props;

  useEffect(() => {
    if (props.files.length !== 0) {
      setChatBarFullMode(true);
    }
  }, [props.files.length]);

  const fixFailure = uuid => {
    const filesToReupload =
      uuid === undefined
        ? props.files.filter(item => item.uploadedToDb === false)
        : props.files.filter(item => item.uuid === uuid);

    filesToReupload.forEach(async item => {
      await props.updateUploadedToDbStatus({
        uuid: item.uuid,
        uploadedToDbStatus: null,
      });
      dispatch(updateFileToDb(item, item.currentStateSnapshot));
    });
  };

  const cancels3Upload = item => {
    const key = `subjects/${currentState.subjectId}/${item.uuid}-${item.fileName}`;
    const [cancelUploadObject] = uploadObjects.filter(obj => obj.key === key);
    cancelUploadObject.upload.abort();
    dispatch(
      UpdateFileCancelAction({
        id: item.id,
        cancelledStatus: true,
        newUuid: uuidv4(),
      })
    );
    dispatch(
      UpdateFileInqueueAction({
        file: item,
        flag: false,
      })
    );
  };

  const isFileUploadable = item => !item.inQueue && !item.uploadedToDb && !item.uploadedToS3;
  const getUploadableFiles = () => props.files.filter(item => isFileUploadable(item));

  const uploadAll = () => {
    props.clearUploaded();
    getUploadableFiles().forEach(file => {
      const { id, currentStateSnapshot } = file;
      const isCancelUpdated = dispatch(
        UpdateFileCancelAction({
          id,
          cancelledStatus: false,
        })
      );
      const isInqueueUpdated = dispatch(
        UpdateFileInqueueAction({
          file,
          flag: true,
        })
      );
      if (isInqueueUpdated && isCancelUpdated) {
        s3Upload(file, currentStateSnapshot);
      }
    });
  };

  const getS3PathForFileUpload = ({ isSubjectsFolder, subjectId, unitId }, { uuid, fileName }) =>
    isSubjectsFolder
      ? `subjects/${subjectId}/${uuid}-${fileName}`
      : `preview-videos/${unitId}/${uuid}-${fileName}`;

  const s3Upload = (item, currentStateSnapshot) => {
    const { uuid, fileData } = item;

    const uploadParams = {
      Bucket: getEnvVars().s3BucketFileExplore,
      Key: getS3PathForFileUpload(currentStateSnapshot, item),
      Body: fileData,
    };

    // call S3 to retrieve upload file to specified bucket
    const upload = s3.upload(uploadParams);
    upload.on('httpUploadProgress', function(progress) {
      let progressUpdate = Math.floor((progress.loaded / progress.total) * 100);
      updateFile({
        uuid,
        progressUpdate,
      });
    });
    const promise = upload.promise();
    promise.then(
      () => {
        dispatch(updateFileToDb(item, currentStateSnapshot));
      },
      err => {
        console.log('Error', err);
        props.updateUploadedToS3Status({
          uuid: item.uuid,
          uploadedToS3Status: false,
        });
      }
    );
    setUploadObjects(state => [
      ...state,
      { key: getS3PathForFileUpload(currentStateSnapshot, item), upload },
    ]);
  };
  const trimmedText = item => {
    return item.fileName && item.fileName.length > 30
      ? `${item.fileName}`.substring(0, 27) + '...'
      : `${item.fileName}`;
  };

  const handleChatbarClick = () => {
    if (props.files.length > 0) {
      setChatBarFullMode(!chatBarFullMode);
    }
  };
  const files = props.files.map((item, index) => {
    return (
      <UploadRow key={index}>
        {/* file name and size */}
        <UploadFileView>
          <InsertDriveFileOutlinedIcon fontSize="large" style={{ marginRight: '10px' }} />
          <div>
            <Typography variant="h6">{trimmedText(item)}</Typography>
            <Typography variant="caption">{`${bytesToSize(item.fileData.size)}`}</Typography>
          </div>
        </UploadFileView>
        <UploadRowAction>
          {/* progress percentage */}
          {item.progressNum > 0 && item.progressNum < 100 && item.cancelled === false && (
            <CircularProgress
              style={{ marginLeft: 5 }}
              variant="static"
              value={item.progressNum}
              size={25}
            />
          )}
          {/* done, clear, cancel  */}
          {item.cancelled === true && <Label color="error">Cancelled</Label>}
          {item.progressNum === 100 && (
            <>
              {item.uploadedToS3 === null && item.cancelled === false && item.progressNum < 100 && (
                <IconButton
                  aria-label="Done"
                  onClick={() => props.onClear(item.uuid)}
                  color="primary"
                >
                  <Icon style={{ color: '#546e7a' }}>radio_button_unchecked</Icon>
                </IconButton>
              )}
              {item.uploadedToS3 === true && (
                <IconButton
                  aria-label="Done"
                  onClick={() => props.onClear(item.uuid)}
                  color="primary"
                >
                  <Icon style={{ color: '#4CAF50' }}>check_circle</Icon>
                </IconButton>
              )}
              {item.uploadedToS3 === false && (
                <IconButton
                  aria-label="Done"
                  onClick={() => props.onClear(item.uuid)}
                  color="primary"
                >
                  <Icon style={{ color: '#dc3c3c' }}>cancel</Icon>
                </IconButton>
              )}
              {item.uploadedToDb === null && item.cancelled === false && item.progressNum < 100 && (
                <IconButton aria-label="progress" color="primary">
                  <Icon style={{ color: '#546e7a' }}>cloud_queue</Icon>
                </IconButton>
              )}
              {item.uploadedToDb === true && (
                <IconButton
                  aria-label="Done"
                  onClick={() => props.onClear(item.uuid)}
                  color="primary"
                >
                  <Icon style={{ color: '#4CAF50' }}>cloud_done</Icon>
                </IconButton>
              )}
              {item.uploadedToDb === false && (
                <IconButton
                  aria-label="failed"
                  onClick={() => fixFailure(item.uuid)}
                  color="#dc3c3c"
                >
                  <Icon style={{ color: '#dc3c3c' }}>cloud_off</Icon>
                </IconButton>
              )}
            </>
          )}

          {item.progressNum > 0 && item.progressNum < 100 && item.cancelled === false && (
            <IconButton onClick={() => cancels3Upload(item)} aria-label="Cancel upload">
              <Icon>delete_outline</Icon>
            </IconButton>
          )}
        </UploadRowAction>
      </UploadRow>
    );
  });

  if (!chatBarFullMode) {
    return (
      isSignedin &&
      props.files.length > 0 && (
        <UploadBar onClick={handleChatbarClick}>
          <p className={classes.headerText}>{`${props.files.length} items in progress`}</p>
          <Icon className={classes.headerIcon}>expand_less</Icon>
        </UploadBar>
      )
    );
  } else {
    return (
      isSignedin &&
      props.files.length > 0 && (
        <UploadBarFull>
          <UploadBarTop onClick={() => setChatBarFullMode(!chatBarFullMode)}>
            <p className={classes.headerText}>{`${props.files.length} items in progress`}</p>
            <Icon className={classes.headerIcon}> expand_more</Icon>
          </UploadBarTop>
          {props.files.length > 0 && (
            <ButtonHeader>
              {/* upload, clear and fix button */}
              <Button
                variant="contained"
                color="primary"
                onClick={() => fixFailure()}
                className={classes.button}
                style={{
                  visibility:
                    props.files.filter(file => file.uploadedToDb === false).length === 0
                      ? 'hidden'
                      : 'initial',
                }}
              >
                FIX FAILURES ({props.files.filter(file => file.uploadedToDb === false).length})
              </Button>
              <div>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => uploadAll()}
                  className={classes.button}
                  disabled={
                    // File is uploadable if File Not in Queue &&
                    props.files.find(
                      // file => !file.inQueue && (file.cancelled === false || (file.cancelled === true && file.progressNum === 100)))
                      file => !file.inQueue
                    )
                      ? false
                      : true
                  }
                >
                  Upload All
                </Button>
                <Button
                  variant="outlined"
                  color="default"
                  onClick={() => props.clearUploaded()}
                  className={clsx(classes.button, classes.clearButton)}
                >
                  Clear Uploaded
                </Button>
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={() => props.allClear()}
                  className={clsx(classes.button, classes.clearAllButton)}
                  disabled={
                    props.files.every(
                      file =>
                        (file.inQueue === true && file.uploadedToDb !== null) ||
                        (file.cancelled === true && file.progressNum !== 0) ||
                        (file.inQueue === false && file.progressNum === 0) ||
                        (file.inQueue === true && file.uploadedToS3 === false)
                    )
                      ? false
                      : true
                  }
                >
                  Clear All
                </Button>
              </div>
            </ButtonHeader>
          )}
          <UploadList>{files}</UploadList>
        </UploadBarFull>
      )
    );
  }
};

const mapStateToProps = state => {
  return {
    files: state.fileExplorerReducer.files,
    currentState: state.fileExplorerReducer.currentState,
    rawEachSubject: state.fileExplorerReducer.rawEachSubject,
    data: state.fileExplorerReducer.currentList,
    isSignedin: state.loginState.loginSuccess,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    addFile: data => dispatch(addFile(data)),
    updateFile: data => dispatch(updateFile(data)),
    updateUploadedToDbStatus: data => dispatch(updateFileUploadedToDb(data)),
    updateUploadedToS3Status: data => dispatch(updateFileUploadedToS3(data)),
    onClear: uuid => dispatch(onClear(uuid)),
    allClear: () => dispatch(allClear()),
    clearUploaded: () => dispatch(clearUploaded()),
    setData: load => dispatch(updateCurrentList(load)),
    updateData: load => dispatch(appendCurrentList(load)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ChatBar);
